import useClickOutside from '../../components/reusables/colorpicker/useClickOutside';
import { closeModalAnimation } from '../../components/Modal/modal-actions/modal-actions';
import FansRevenueLogo from '../../components/reusables/svg/FansRevenuLogo.react';
import messages from '../../i18n/base-en';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { setActionMessage } from '../../components/Application/actions/application-actions';
import consts from '../../utils/consts';
const { REFERRAL_LINK_URL_FR } = consts;
const FansrevenuReferralsModal = ({ affId, dispatch, modalInner, rate, intl }) => {
  const closeOpenModal = () => {
    dispatch(closeModalAnimation());
  };

  useClickOutside(modalInner, closeOpenModal);

  const copyFRLink = () => {
    const text = `${REFERRAL_LINK_URL_FR}?r=${affId}`;
    navigator.clipboard.writeText(text);
    dispatch(
      setActionMessage(
        'success',
        {
          text: intl.formatMessage(messages.genericTextTextCopied, { text }),
        },
        3000
      )
    );
  };
  return (
    <div className="modal-box">
      <div className="modal-content">
        <div className="header-banner fansrevenue">
          <FansRevenueLogo className="fr-logo" />
        </div>
        <div className="content-box">
          <h2>
            <FormattedHTMLMessage {...messages.referralsModalFRtitle} />
          </h2>
          <FormattedHTMLMessage {...messages.referralsModalFRDescription} values={{ rate }} />
        </div>
        <button className="btn" onClick={() => copyFRLink()} type="button">
          <FormattedHTMLMessage {...messages.referralsFRModalCopyLink} />
        </button>
      </div>
    </div>
  );
};
export default injectIntl(FansrevenuReferralsModal);
